import React from "react";
import BaseSpread, { CardPosition } from "./BaseSpread";

// Generate position data for Tetraktys spread (10 cards)
// Cards are arranged in a pyramid formation:
// Row 1: 1 card at top
// Row 2: 2 cards 
// Row 3: 3 cards
// Row 4: 4 cards at bottom
const generateTetraktysPositions = (spacing: number = 12): CardPosition[] => {
    const cardHeight = spacing * 1.726; // Maintain card aspect ratio (standard tarot card ratio)
    const verticalGap = spacing * 2.2; // Vertical spacing between rows
    const horizontalUnit = spacing * 1.1; // Base horizontal spacing unit

    return [
        // Row 1: 1 card (top center)
        { left: horizontalUnit * 2.25, top: 0, width: spacing, height: cardHeight },           // 0: Spiritual essence (top)

        // Row 2: 2 cards
        { left: horizontalUnit * 1.5, top: verticalGap, width: spacing, height: cardHeight },    // 1: Intuition (left)
        { left: horizontalUnit * 3, top: verticalGap, width: spacing, height: cardHeight },    // 2: Logic (right)

        // Row 3: 3 cards
        { left: horizontalUnit * 0.75, top: verticalGap * 2, width: spacing, height: cardHeight }, // 3: Past influences
        { left: horizontalUnit * 2.25, top: verticalGap * 2, width: spacing, height: cardHeight }, // 4: Present situation
        { left: horizontalUnit * 3.75, top: verticalGap * 2, width: spacing, height: cardHeight }, // 5: Future potential

        // Row 4: 4 cards (bottom row)
        { left: horizontalUnit * 0, top: verticalGap * 3, width: spacing, height: cardHeight }, // 6: Material world
        { left: horizontalUnit * 1.5, top: verticalGap * 3, width: spacing, height: cardHeight }, // 7: Emotional realm
        { left: horizontalUnit * 3, top: verticalGap * 3, width: spacing, height: cardHeight }, // 8: Mental realm
        { left: horizontalUnit * 4.5, top: verticalGap * 3, width: spacing, height: cardHeight }  // 9: Spiritual realm
    ];
};

interface TetraktysSpreadProps {
    size?: number;
    cardWidth: number;
    displaySpread: boolean;
    getCard: (index: number) => React.ReactNode;
    spacing?: number; // Spacing between cards (default: 12)
}

const TetraktysSpread = ({ size, cardWidth, displaySpread, getCard, spacing = 12 }: TetraktysSpreadProps) => {
    const positions = generateTetraktysPositions(spacing);

    return (
        <BaseSpread
            positions={positions}
            size={size}
            cardWidth={cardWidth}
            displaySpread={displaySpread}
            getCard={getCard}
            rotatedCards={[]} // No rotated cards in tetraktys spread
            name="tetraktys"
        />
    );
};

export default TetraktysSpread; 